import {
  Component,
  OnInit,
  ElementRef,
  QueryList,
  ViewChildren,
} from "@angular/core";
import {
  AlertService,
  LoadingService,
} from "../../services";
import { FileUploader } from "ng2-file-upload";
import { P2PScheduleService } from "app/services/p2p-schedule.service";
import {
  FormGroup,
  FormBuilder,
} from "@angular/forms";
import { Util } from 'app/utils';

@Component({
  selector: "p2p-schedule-upload",
  templateUrl: "p2p-schedule-upload.html",
})
export class P2PScheduleUpload implements OnInit {
  @ViewChildren("checkItems") checkItems: QueryList<ElementRef>; // 리스트 checkbox

  headerTextList: string[] = [
    "ExcelLine",
    "Line CD",
    "Vessel Name",
    "Voyage",
    "From",
    "To",
    "Msg",
  ];
  showExcelList; //표출 될 excelList
  excelList;

  vesselName; // 선사명

  uploader: FileUploader = new FileUploader({});

  uploadFileForm: FormGroup;

  showExcelResult = false;
  showModal = false;
  checkedAllListFlag = false;
  checkedCount = 0;
  finalUploadFile;

  formData;

  selectedList = [];

  fileName= '';

  uploaderVal;
  objectKeys = Object.keys;

  constructor(
    private loadingService: LoadingService,
    private p2pScheduleService: P2PScheduleService,
    private formBuilder: FormBuilder,
    private alert: AlertService
  ) {}

  ngOnInit(): void {
    this.uploadFileForm = this.formBuilder.group({
      file: [""],
    });
  }

  // 선사 선택
  selectVessel(vessel) {
    this.vesselName = vessel;
  }

  // row 클릭시 해당 리스트를 선택한다.
  addSelectList(index: number) {
    const existIdx = this.selectedList.indexOf(index);
    const existIdxFlag = existIdx > -1;
    if (existIdxFlag) {
      this.selectedList.splice(existIdx, 1);
    } else {
      this.selectedList.push(index);
    }

    this.checkedCount = this.checkItems
      .toArray()
      .filter((item) => item.nativeElement.checked).length;
    if (this.excelList.length === this.checkedCount) {
      this.checkedAllListFlag = true;
    } else {
      this.checkedAllListFlag = false;
    }
  }

  // 파일 찾기 value text
  getUploadFileName() {
    if (this.uploader && this.uploader.queue && this.uploader.queue.length) {
      const qLastIdx = this.uploader.queue.length - 1;
      return this.uploader.queue[qLastIdx].file.name;
    } else {
      return "";
    }
  }

  // 업로드 버튼
  async upLoadFile() {
    if (!(this.uploader && this.uploader.queue && this.uploader.queue.length)) {
      return;
    }

    this.loadingService.loadingMsg = "파일 업로드중...";
    this.showExcelResult = true;
    this.showExcelList = [];
    this.excelList = [];

    this.getListAPI();
  }

  getListAPI() {
    this.loadingService.isClose = false;
    this.formData = new FormData();
    this.formData.append("file", this.finalUploadFile);

    try {
      this.p2pScheduleService.examineExcelUpload(
        this.vesselName,
        this.formData,
        (res) => {
          if (res && res.statusCode === 200) {
            this.excelList = res.p2pScheduleList;
            this.showExcelList = res.p2pScheduleList.map(
              list => {
                const arr = {
                  excelLine: list.excelLine,
                  lineCd: list.lineCd,
                  vesselNm: list.vesselNm,
                  voyage: list.voyage,
                  depPortNm: list.depPortNm,
                  arrPortNm: list.arrPortNm,
                  msg: list.msg
                }
                return arr;
              }
            );
          } else {
            this.alert.error(res.msg);
          }
          this.loadingService.isClose = true;
        },
        (error) => {
          this.alert.error(error);
        },
        () => {
          this.loadingService.isClose = true;
        }
      );
    } catch (err) {
      this.alert.error(err);
      this.loadingService.isClose = true;
    }
  }

  // 전체 선택
  checkAll() {
    this.checkedAllListFlag = !this.checkedAllListFlag;
    const checkList = this.checkItems.toArray();
    for (let i = 0; i < checkList.length; i++) {
      checkList[i].nativeElement.checked = this.checkedAllListFlag;
    }

    if (this.checkedAllListFlag) {
      this.checkedCount = checkList.length;
    } else {
      this.checkedCount = 0;
      this.selectedList = [];
    }
  }

  // 파일 찾기 버튼 클릭시 초기화 작업
  resetUploader() {
    // this.uploader.cancelAll();
    // this.uploader.clearQueue();
  }

  // 파일 업로드(파일 선택 시)
  uploadPicFile(fileInput: any) {
    let reader = new FileReader();

    if (fileInput && fileInput.target.files && fileInput.target.files.length) {
      const [file] = fileInput.target.files;
      reader.readAsDataURL(file);
      // this.showModal = true;
      const files = fileInput.target.files[0];
        if (!!files) {
        this.finalUploadFile = files;
        this.uploadFileForm.get("file").setValue(files);
        this.fileName = files.name;
        }
    } else {
    }
  }

  modalClose() {
    this.showModal = false;
  }

  // 등록 (전송)
  registList() {
    this.transList();
  }

  // 취소
  resetInput() {
    this.showModal = false;
    this.uploader.clearQueue();
    this.showExcelResult = false;
    this.checkedCount = 0;
    
    // this.uploadFileForm.get("file").setValue(null);
    this.fileName = '';
  }

  // 파일 전송
  showUploadModal() {
    if (!this.vesselName) {
      Util.alertWarn("선사를 선택하세요");
      return;
    }
    if (!(this.uploader && this.uploader.queue && this.uploader.queue.length)) {
      return;
    }
    this.showModal = true;
  }

  // 파일을 업로드 하시겠습니까 ? 예
  submitExceList() {
    this.checkedCount = 0;
    this.selectedList = [];
    this.showExcelResult = false;
    this.showModal = false;
    this.checkedAllListFlag = false;
    this.upLoadFile();
  }
    
  // 선택한 list api 전송
  async transList() {
    this.loadingService.isClose = false;
    this.loadingService.loadingMsg = "스케줄 등록중...";

    let lists;

    if (this.checkedAllListFlag) {
      // lists = this.excelList.filter((list) => !list.errorYn);
      lists = this.excelList; // 2021/07/19 선사 비고 데이터가 있는 경우에도 선택할 수 있도록 수정
    } else {
      lists = this.excelList.filter((list, i) => this.selectedList.includes(i));
    }

    

    try {
      this.p2pScheduleService.submitExcelList(
        this.vesselName,
        lists,
        (res) => {
          if (res) {
            this.loadingService.isClose = true;
            alert(`총 ${res}건의 스케줄이 등록 되었습니다.`);
            this.resetInput();
          } else {
            // this.alert.error();
            this.resetInput();
          }
          this.loadingService.isClose = true;
        },
        (error) => {
          this.alert.error(error);
        },
        () => {
          this.loadingService.isClose = true;
          this.fileName = '';
          // this.uploadFileForm.get("file").setValue(null);
          this.uploader = new FileUploader({});
        }
      );
    } catch (err) {
      this.alert.error(err);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/p2p-schedule-upload/p2p-schedule-upload.ts